import { rem } from 'polished';
import styled from 'styled-components';
import { mediaQueryWidth } from '../../../common/breakpoints';
import { darkGrey3, white } from '../../../common/colors';

export interface TourFeatureVideoStylesProps {
  first?: boolean;
}

export const FeatureVideoContainer = styled.div<TourFeatureVideoStylesProps>`
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 50%;
  display: flex;
  flex-direction: column;
  background-color: ${darkGrey3};
  box-sizing: border-box;

  .youtube-container {
    flex: 1;
  }

  ${({ first }) => (first ? 'top: 0' : 'bottom: 0')}

  ${mediaQueryWidth({ min: 'tablet' })`
    padding: 0 120px 45px 120px;
    height: 100%;
  `}
`;

export const FeatureVideoCloseButton = styled.div`
  position: absolute;
  top: 30px;
  right: 10px;
  width: ${rem(16)};
  height: ${rem(16)};
  color: ${white};
  cursor: pointer;

  ${mediaQueryWidth({ min: 'mobile' })`
    top: 40px;
    right: 30px;
  `}
`;

export const FeatureVideoButtonContainer = styled.div`
  order: 1;
  padding: 60px 0 20px 0;
  text-align: center;
  white-space: nowrap;

  ${mediaQueryWidth({ min: 'tablet' })`
    position: absolute;
    top: 30px;
    right: 120px;
    padding: 0;
  `}

  & > a:not(:last-child) {
    margin: 0 15px 0 0;

    ${mediaQueryWidth({ min: 'mobile' })`
      margin: 0 20px 0 0;
    `}
  }
`;

export const FeatureVideoText = styled.div`
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  font-weight: 500;
  color: ${white};
  padding: 20px 0 45px 20px;

  & > span {
    display: block;
    font-weight: 800;
    font-size: ${rem(20)};
    line-height: ${rem(25)};
  }

  ${mediaQueryWidth({ min: 'mobile', max: 'tablet' })`
    padding: 30px 0 45px 30px;
  `}

  ${mediaQueryWidth({ min: 'tablet' })`
    font-size: ${rem(20)};
    line-height: ${rem(24)};
    padding: 30px 0;

    & > span {
      display: inline-block;
      margin-left: ${rem(10)};
      font-size: ${rem(30)};
      line-height: ${rem(37)};
    }
  `}
`;
